import React, { useState } from "react"
import moment from "moment"
import Modal from "../../components/Modal"
import DatePicker from "../../components/Form/DatePicker"
import Button from "../../components/Form/Button"
import styles from "./outboundCampaignList.module.css"

const CampaignScheduleModal = ({ count = 1, onSubmit, closeModal }) => {
    const [date, setDate] = useState(moment().add(1, "hour").format("YYYY-MM-DD"))
    const [time, setTime] = useState(moment().add(1, "hour").format("HH:mm"))
    const [loading, setLoading] = useState(false)

    const handleSubmit = async event => {
        event.preventDefault()
        setLoading(true)
        try {
            await onSubmit(moment(`${date} ${time}`, "YYYY-MM-DD HH:mm").toISOString())
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal title="Reagendar campanhas" description={`${count} campanha${count === 1 ? "" : "s"} selecionada${count === 1 ? "" : "s"}`} closeModal={closeModal} fitContent>
            <form className={styles.scheduleForm} onSubmit={handleSubmit}>
                <p>Campanhas em rascunho, agendadas ou pausadas serão programadas para o novo horário.</p>
                <DatePicker
                    name="Data e horário do envio"
                    dateStart={date}
                    timeStart={time}
                    min={moment().startOf("day")}
                    multiple={false}
                    showTime
                    onChange={(nextDate, _dateEnd, nextTime) => {
                        setDate(nextDate)
                        setTime(nextTime || time)
                    }}
                />
                <div className={styles.modalActions}>
                    <Button type="submit" disabled={loading}>{loading ? "Reagendando…" : "Confirmar agendamento"}</Button>
                    <Button type="button" variant="secondary" onClick={closeModal}>Cancelar</Button>
                </div>
            </form>
        </Modal>
    )
}

export default CampaignScheduleModal
